import React from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import PdfViewer from "./PdfViewer";

/**
 * Reusable modal hosting the PdfViewer iframe. Pass the PDF `src`
 * (direct URL or blob/object URL) and control visibility via `open`/`onClose`.
 */
const PdfModal = ({
  open,
  onClose,
  src,
  title = "Document",
  maxWidth = "lg",
  useProxy = false,
}) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth={maxWidth} fullWidth>
      <DialogTitle
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          pr: 1,
        }}
      >
        {title}
        <IconButton onClick={onClose} size="small" aria-label="close">
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers sx={{ p: 0 }}>
        <PdfViewer src={src} title={title} useProxy={useProxy} />
      </DialogContent>
    </Dialog>
  );
};

export default PdfModal;
